import useSWR from 'swr';
import { cmsService, isApiError } from '@dopomogai/api-client';
import type { CmsDocument, CmsPublicDocument } from '@dopomogai/types';
import { AgentKitError } from '../../types';

// The fetcher now expects an array key: [namespace, locale]
const documentFetcher = async ([, namespace, locale]: [string, string, string | undefined]) => {
  const response = await cmsService.getDocument(namespace, locale);
  if (isApiError(response)) {
    throw new AgentKitError(`Failed to fetch document: ${namespace}`, response);
  }
  return response;
};

/**
 * A read-only hook for fetching public or admin-preview CMS document data.
 * All mutation logic has been moved to a dedicated admin hook.
 */
export const useCmsDocument = (namespace?: string, locale?: string) => {
  const { data, error, isLoading, mutate } = useSWR<
    CmsDocument | CmsPublicDocument,
    AgentKitError
  >(
    // CORRECTED KEY: The key is now a clean array of identifiers.
    // The first element 'cms-document' acts as a unique scope for this hook's cache.
    namespace ? ['cms-document', namespace, locale] : null,
    documentFetcher
  );

  return {
    document: data,
    isLoading,
    error,
    mutate,
  };
};